export const API_BASE_URL = "https://learnwebacademy.net/learnweb-api";
// export const API_BASE_URL = "http://localhost:4000/learnweb-api";

export const FILE_UPLOAD_URL = "https://learnwebacademy.net/assets";